import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex align-items-center px-3 mt-4 gap-2" }

import {useStore} from "vuex"

// Components
import FlightOriginDropdown from './flightOriginDropDown.vue';
import FlightDatePicker from "./flightDatePicker.vue"
import FlightParticipants from './flightParticipants.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'flightDetails',
  setup(__props) {

// Vuex
const store = useStore()


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(FlightOriginDropdown),
    _createVNode(FlightDatePicker),
    _createVNode(FlightParticipants)
  ]))
}
}

})